export default __webpack_public_path__ + "static/media/job_offer19_xl.5f14e9b6.jpg";